// compareData.js
// Single source of truth for the Compare section (competitor comparison pages).
// Both CompareIndex (to list cards) and CompareArticle (to look up its own
// metadata for <title>/meta injection) read from this array.
//
// To add a comparison:
//   1. Add an entry here (slug must match the article component + route).
//   2. Create the article component in ./articles/.
//   3. Register it in the ARTICLE_COMPONENTS map in CompareArticle.js.
//
// Slug rules: lowercase, hyphenated, IS the target keyword (e.g.
// 'tee-time-helper-alternative'). Permanent once published (changing a live
// slug loses ranking unless you add a redirect).
//
// ACCURACY NOTE: every competitor claim on these pages must be sourced from the
// competitor's published site and date-stamped. Re-verify quarterly. Never
// state a competitor price unless it's live on their public pricing page.

export const COMPARISONS = [
  {
    slug: 'tee-time-helper-alternative',
    competitor: 'Tee Time Helper',
    title: 'Tee Time Helper Alternative: How Tee Time Organizer Compares (2026)',
    metaDescription:
      'Tee Time Helper alternative for golf group organizers. Tee Time Helper handles scheduling and RSVPs; Tee Time Organizer adds GHIN handicaps, weather, scoring, and league tools in one platform.',
    keyword: 'tee time helper alternative',
    excerpt:
      'Tee Time Helper is a solid, established way to schedule rounds and track RSVPs. Here is where a more feature-rich golf platform fits — from a founder who was a Tee Time Helper subscriber first.',
    datePublished: '2026-06-26',
    dateModified: '2026-06-26',
    readMinutes: 6,
    published: true,
  },
  {
    slug: 'golf-league-tracker-alternative',
    competitor: 'Golf League Tracker',
    title: 'Golf League Tracker Alternative: How Tee Time Organizer Compares (2026)',
    metaDescription:
      'Golf League Tracker alternative. Golf League Tracker is a deep, league-first tool; Tee Time Organizer is a broader platform for buddies groups, MGAs, LGAs, and casual play that runs leagues too.',
    keyword: 'golf league tracker alternative',
    excerpt:
      'Golf League Tracker goes deep on competitive leagues. Tee Time Organizer is broader — built for buddies groups, associations, and casual play, and it runs leagues too. Here is how to tell which fits.',
    datePublished: '2026-06-26',
    dateModified: '2026-06-26',
    readMinutes: 7,
    published: true,
  },
];

// Helper: only comparisons that are actually live (have a component).
export const getPublishedComparisons = () => COMPARISONS.filter((c) => c.published);

// Helper: look up a single comparison by slug.
export const getComparisonBySlug = (slug) => COMPARISONS.find((c) => c.slug === slug);

// Re-export the shared palette from guidesData so the Compare section is
// visually identical to Guides and the rest of the site (single source of the
// color tokens — do not duplicate the hex values here).
export { colors } from '../guides/guidesData';
